const about = {
  hero: {
    badge: "Nuestra Historia",
    title: "Familia, Confianza y Dedicación",
    subtitle: "Somos Adry & Mich — un negocio familiar construido sobre trabajo duro, honestidad y un amor genuino por ayudar a nuestra comunidad.",
  },
  story: {
    title: "Quiénes Somos",
    p1: "Con sede en Royal Palm Beach, FL, comenzamos Adry & Mich Cleaning and Handyman Service con un objetivo simple: cuidar tu hogar para que no tengas que preocuparte.",
    p2: "Como negocio familiar, aportamos un toque personal a cada trabajo. Tratamos tu hogar como el nuestro — con cuidado, respeto y atención a cada detalle.",
    p3: "Desde limpieza regular hasta reparaciones complejas, somos tu solución integral de cuidado del hogar. Nuestros clientes confían en nosotros porque llegamos, hacemos el trabajo bien y siempre comunicamos abiertamente.",
    years: "Años de Experiencia",
    clients: "Clientes Satisfechos",
    rating: "Calificación Promedio",
  },
  values: {
    title: "Nuestros Valores",
    items: [
      {
        icon: "ri-heart-line",
        title: "La Familia Primero",
        desc: "Tratamos a cada cliente como familia. Tu hogar es nuestra responsabilidad y nos la tomamos en serio.",
      },
      {
        icon: "ri-shield-check-line",
        title: "Confianza y Honestidad",
        desc: "Somos transparentes sobre precios, tiempos y lo que podemos hacer. Sin sorpresas ni cargos ocultos.",
      },
      {
        icon: "ri-medal-line",
        title: "Trabajo de Calidad",
        desc: "No nos vamos hasta que el trabajo esté bien hecho. Tu satisfacción es nuestro estándar.",
      },
    ],
  },
  area: {
    title: "Área de Servicio",
    subtitle: "Servimos con orgullo a Royal Palm Beach y sus alrededores en el Condado de Palm Beach, FL — sin importar dónde estés, estamos para ayudarte.",
    areas: ["Royal Palm Beach", "Wellington", "West Palm Beach", "Palm Beach Gardens", "Lake Worth", "Boynton Beach"],
  },
  schedule: {
    title: "Horario de Atención",
    days: "Lunes – Sábado",
    hours: "8:00 AM – 4:00 PM",
    note: "Disponibles para servicios de emergencia — ¡contáctanos!",
  },
  payment: {
    title: "Métodos de Pago",
    methods: ["Efectivo", "Zelle", "Cheque"],
  },
};

export default about;
